<div class="slider border-radius">
  <img
    src="assets/sunset.webp"
    width="1500"
    height="941"
    alt="Sunset"
    class="slider__bg"
  />
  <div class="slider__content">
    <div class="heading heading_large heading_centered">Images base</div>
    <div class="slider__subtitle">
      Here you will find only the highest quality content
    </div>
    <app-search />
    <app-trending />
    @defer {
      <app-highlights />
    } @placeholder {
      <div class="highlights-placeholder"></div>
    }
  </div>
</div>
